import Utils from "../utils/Utils";

const ProductController = {
  getProductDetails: ({ productRequest, Authorization }) => {
    return Utils.controller(
      "api/product/v1/getProductDetails",
      productRequest,
      "POST",
      "",
      true,
      Authorization,
      true,
    );
  },

  getProductCatalogDetails: ({ productRequest, Authorization }) => {
    return Utils.controller(
      "api/product/v1/getProductCatalogDetails",
      "",
      "GET",
      `productId=${productRequest?.productId || ""}`,
      true,
      Authorization,
      true,
    );
  },

  // getProductCatalog: ({ productRequest, jwt }) => {
  //   return Utils.controller(
  //     "api/product/v1/getProductCatalog",
  //     productRequest,
  //     "GET",
  //     "",
  //     true,
  //     jwt,
  //     true,
  //   );
  // },

  updateProductCatalog: ({ request, Authorization, productId }) => {
    return Utils.controller(
      "api/product/v1/updateProductCatalog",
      request,
      "PUT",
      `productId=${productId}`,
      true,
      Authorization,
      true,
    );
  },

  getProductRequests: ({ ProductRequestsDTO, jwt }) => {
    return Utils.controller(
      "api/product/v1/productRequests",
      ProductRequestsDTO,
      "GET",
      "",
      true,
      jwt,
      true,
    );
  },

  sendRejectedEmail: ({ productEmail, jwt }) => {
    return Utils.controller(
      "api/product/v1/rejectedEmail",
      productEmail,
      "POST",
      "",
      true,
      jwt,
      true,
    );
  },

  sendResubmissionEmail: ({ productEmail, jwt }) => {
    return Utils.controller(
      "api/product/v1/resubmissionEmail",
      productEmail,
      "POST",
      "",
      true,
      jwt,
      true,
    );
  },

  sendApprovedEmail: ({ productEmail, jwt }) => {
    return Utils.controller(
      "api/product/v1/approvedEmail",
      productEmail,
      "POST",
      "",
      true,
      jwt,
      true,
    );
  },

  addproductdetails: ({ productDTO, jwt }) => {
    return Utils.controller(
      "api/product/v1/updateCompanyDescription",
      productDTO,
      "POST",
      "",
      true,
      jwt,
      true,
    );
  },

  addupdateproductdetails: ({ productDetailsRequest, jwt }) => {
    return Utils.controller(
      "api/product/v1/addUpdateProductDetails",
      productDetailsRequest,
      "PUT",
      "",
      true,
      jwt,
      true,
    );
  },

  getPromotions: ({ Authorization, companyId }) => {
    return Utils.controller(
      "api/promotion/v1/getPromotions",
      "",
      "GET",
      `companyId=${companyId}`,
      true,
      Authorization,
      true,
    );
  },

  getFeaturedCategories: ({ Authorization, companyId }) => {
    return Utils.controller(
      "api/featured/v1/getFeaturedCategories",
      "",
      "GET",
      `companyId=${companyId}`,
      true,
      Authorization,
      true,
    );
  },
  getAllCategories: ({ Authorization }) => {
    return Utils.controller(
      "api/product/v1/getAllCategories",
      "",
      "GET",
      "",
      true,
      Authorization,
      true,
    );
  },
  getCategories: ({ Authorization }) => {
    return Utils.controller(
      "api/product/v1/admin/getCategories",
      "",
      "GET",
      "",
      true,
      Authorization,
      true,
    );
  },
  getProductCatalog: ({
    Authorization,
    productRequest = {},
    brand = productRequest.brand,
    categoryId = productRequest.categoryId,
    color = productRequest.color,
    companyID = productRequest.companyID,
    maxPrice = productRequest.maxPrice,
    minPrice = productRequest.minPrice,
    productCompanyStatus = productRequest.productCompanyStatus,
    productSystemStatus = productRequest.productSystemStatus,
    page = productRequest.page,
    search = productRequest.search,
    size = productRequest.size,
    sizePage = productRequest.sizePage,
    sortBy = productRequest.sortBy,
    sortDirection = productRequest.sortDirection,
  }) => {
    const params = new URLSearchParams();

    if (brand) params.append("brand", brand);
    if (categoryId) params.append("categoryId", categoryId);
    if (
      productCompanyStatus !== undefined &&
      productCompanyStatus !== null &&
      productCompanyStatus !== ""
    )
      params.append("productCompanyStatus", productCompanyStatus);
    if (
      productSystemStatus !== undefined &&
      productSystemStatus !== null &&
      productSystemStatus !== ""
    )
      params.append("productSystemStatus", productSystemStatus);
    if (color) params.append("color", color);
    if (companyID) params.append("companyID", companyID);
    if (maxPrice) params.append("maxPrice", maxPrice);
    if (minPrice) params.append("minPrice", minPrice);
    if (page) params.append("page", page);
    if (search) params.append("search", search);
    if (size) params.append("size", size);
    if (sizePage) params.append("sizePage", sizePage);
    if (sortBy) params.append("sortBy", sortBy);
    if (sortDirection) params.append("sortDirection", sortDirection);

    return Utils.controller(
      "api/product/v1/getProductCatalog",
      "",
      "GET",
      params.toString(),
      true,
      Authorization,
      true,
    );
  },
  getCampaignsNameAndId: ({ Authorization }) => {
    return Utils.controller(
      "api/promotion/v1/getCampaignsNameAndId",
      "",
      "GET",
      "",
      true,
      Authorization,
      true,
    );
  },
  addCampaign: ({ Authorization, request }) => {
    return Utils.controller(
      "api/product/v1/addCampaign",
      request,
      "POST",
      "",
      true,
      Authorization,
      true,
    );
  },
  getDraftPromotions: ({ Authorization }) => {
    return Utils.controller(
      "api/promotion/v1/getDraftPromotions",
      "",
      "GET",
      "",
      true,
      Authorization,
      true,
    );
  },
  getPromotionDetailsById: ({ Authorization, productOfferId }) => {
    return Utils.controller(
      "api/promotion/v1/getPromotionDetailsById",
      "",
      "GET",
      `productOfferId=${productOfferId}`,
      true,
      Authorization,
      true,
    );
  },
  updateProduct: ({ productRequestDto, Authorization, productId }) => {
    return Utils.controller(
      "api/product/v1/updateProduct",
      productRequestDto,
      "PUT",
      `productId=${productId}`,
      true,
      Authorization,
      true,
    );
  },
  enhanceProductImage: ({ Authorization, request }) => {
    return Utils.controller(
      "api/product/v1/enhanceProductImage",
      request,
      "POST",
      "",
      true,
      Authorization,
      true,
    );
  },
  startEnhanceProductImageJob: ({ Authorization, request }) => {
    return Utils.controller(
      "api/product/v1/startEnhanceProductImageJob",
      request,
      "POST",
      "",
      true,
      Authorization,
      true,
    );
  },
  deleteProductAttachment: ({ Authorization, request }) => {
    return Utils.controller(
      "api/product/v1/deleteProductAttachment",
      request,
      "DELETE",
      "",
      true,
      Authorization,
      true,
    );
  },
  generateSkuDimensionImage: ({ Authorization, request }) => {
    return Utils.controller(
      "api/product/v1/generateSkuDimensionImage",
      request,
      "POST",
      "",
      true,
      Authorization,
      true,
    );
  },
  startGenerateSkuDimensionImageJob: ({ Authorization, request }) => {
    return Utils.controller(
      "api/product/v1/startGenerateSkuDimensionImageJob",
      request,
      "POST",
      "",
      true,
      Authorization,
      true,
    );
  },
  generateProductVideo: ({ Authorization, request }) => {
    return Utils.controller(
      "api/product/v1/generateProductVideo",
      request,
      "POST",
      "",
      true,
      Authorization,
      true,
    );
  },
  generateVideoFromPhotos: ({ Authorization, request }) => {
    return Utils.controller(
      "api/product/v1/generateVideoFromPhotos",
      request,
      "POST",
      "",
      true,
      Authorization,
      true,
    );
  },
  startGenerateVideoFromPhotosJob: ({ Authorization, request }) => {
    return Utils.controller(
      "api/product/v1/startGenerateVideoFromPhotosJob",
      request,
      "POST",
      "",
      true,
      Authorization,
      true,
    );
  },

  finalizeProductVideo: ({ Authorization, request }) => {
    return Utils.controller(
      "api/product/v1/finalizeProductVideo",
      request,
      "POST",
      "",
      true,
      Authorization,
      true,
    );
  },

  generateSkuDescription: ({ Authorization, request }) => {
    return Utils.controller(
      "api/product/v1/generateSkuDescription",
      request,
      "POST",
      "",
      true,
      Authorization,
      true,
    );
  },
  startGenerateSkuDescriptionJob: ({ Authorization, request }) => {
    return Utils.controller(
      "api/product/v1/startGenerateSkuDescriptionJob",
      request,
      "POST",
      "",
      true,
      Authorization,
      true,
    );
  },
  getAiJobStatus: ({ Authorization, jobId }) => {
    return Utils.controller(
      "api/product/v1/getAiJobStatus",
      "",
      "GET",
      `jobId=${jobId || ""}`,
      true,
      Authorization,
      true,
    );
  },
  getProductAiJobs: ({ Authorization, productId }) => {
    return Utils.controller(
      "api/product/v1/getProductAiJobs",
      "",
      "GET",
      `productId=${productId || ""}`,
      true,
      Authorization,
      true,
    );
  },
  bybarcode: ({ Authorization, barcode }) => {
    const params = new URLSearchParams();

    if (barcode) params.append("barcode", barcode);

    return Utils.controller(
      "api/product/v1/products/by-barcode",
      "",
      "GET",
      params.toString(),
      true,
      Authorization,
      false,
    );
  },

  getSubCategoriesByCategory: ({ Authorization, request }) => {
    return Utils.controller(
      "api/product/v1/admin/getSubCategoriesByCategory",
      request,
      "GET",
      "",
      true,
      Authorization,
      true,
    );
  },
  getAdminSubCategoriesByCategory: ({ Authorization, categoryId }) => {
    return Utils.controller(
      "api/product/v1/admin/getSubCategoriesByCategory",
      "",
      "GET",
      `categoryId=${categoryId}`,
      true,
      Authorization,
      true,
    );
  },
  bulkImportProductsCsv: ({
    Authorization,
    companyId,
    userId,
    file,
    validateOnly,
    formData,
  }) => {
    const requestBody = formData || new FormData();

    if (!formData) {
      requestBody.append("companyId", companyId);
      requestBody.append("userId", userId);
      requestBody.append("validateOnly", validateOnly);
      requestBody.append("file", file);
    }

    return Utils.controller(
      "api/product/v1/bulkImportProductsCsv",
      requestBody,
      "POST",
      "",
      true,
      Authorization,
      true,
    );
  },

  addCategory: ({ Authorization, request }) => {
    return Utils.controller(
      "api/product/v1/admin/addCategory",
      request,
      "POST",
      "",
      true,
      Authorization,
      true,
    );
  },
  deleteCategory: ({ Authorization, categoryId }) => {
    return Utils.controller(
      "api/product/v1/admin/deleteCategory",
      "",
      "DELETE",
      `categoryId=${categoryId}`,
      true,
      Authorization,
      true,
    );
  },
  updateCategory: ({ Authorization, request }) => {
    return Utils.controller(
      "api/product/v1/admin/updateCategory",
      request,
      "PUT",
      "",
      true,
      Authorization,
      true,
    );
  },

  addSubCategory: ({ Authorization, request }) => {
    return Utils.controller(
      "api/product/v1/admin/addSubCategory",
      request,
      "POST",
      "",
      true,
      Authorization,
      true,
    );
  },
  updateSubCategory: ({ Authorization, request }) => {
    return Utils.controller(
      "api/product/v1/admin/updateSubCategory",
      request,
      "PUT",
      "",
      true,
      Authorization,
      true,
    );
  },
  deleteSubCategory: ({ Authorization, subCategoryId }) => {
    return Utils.controller(
      "api/product/v1/admin/deleteSubCategory",
      "",
      "DELETE",
      `subCategoryId=${subCategoryId}`,
      true,
      Authorization,
      true,
    );
  },
  deleteProduct: ({ Authorization, request }) => {
    return Utils.controller(
      "api/product/v1/deleteProduct",
      request,
      "DELETE",
      "",
      true,
      Authorization,
      true,
    );
  },
  updateProductAttachmentOrder: ({ Authorization, request }) => {
    return Utils.controller(
      "api/product/v1/updateProductAttachmentOrder",
      request,
      "PUT",
      "",
      true,
      Authorization,
      true,
    );
  },
  updateProductAttachmentPrimary: ({ Authorization, request }) => {
    return Utils.controller(
      "api/product/v1/updateProductAttachmentPrimary",
      request,
      "PUT",
      "",
      true,
      Authorization,
      true,
    );
  },
};
export default ProductController;
